<div [ngClass]="{ 'stand-alone-modal': standAlone }">
    <div class="modal is-active" [ngClass]="modalSize ? 'is-' + modalSize : ''" role="dialog" aria-modal="true">
        <div class="modal-content">
            <div class="modal-header">
                @if (closeActive) {
                    <button class="modal-close is-large" type="button" (click)="closeClicked()">
                        <span class="sr-only">Close</span>
                    </button>
                }
                <h1 class="title is-level-3">{{ title || params?.title }}</h1>
            </div>
            <div class="modal-body">
                <ng-template #insertionComp></ng-template>
            </div>
            <div data-modal-footer="" class="modal-footer">
                @if (customModalFooter) {
                    <ng-container [ngTemplateOutlet]="customModalFooter" />
                } @else {
                    <button class="button is-primary" type="button" (click)="closeClicked()">Fermer</button>
                }
            </div>
        </div>
    </div>
</div>
